import { createSelector } from 'reselect';
import { jobHelpers } from '@saucelabs/sl-util-helpers';
import { access } from '@saucelabs/sl-module-root-cause';

import { FAILURE_ANALYSIS_EXPERIMENT } from './constants';

const builds = (store) => store.apps.builds.container;

const containerSelector = createSelector([
  builds,
  (store) => store.user,
  (store) => store.experiments,
  (store) => store.apps.builds.rootCauses,
],
(filteredState, user, experiments, rootCauses) => ({
  loading: filteredState.get('loading'),
  build: filteredState.get('build'),
  failureAnalysisEnabled: (
    access.isFailureAnalysisEnabled(user) &&
    experiments.get(FAILURE_ANALYSIS_EXPERIMENT) === FAILURE_ANALYSIS_EXPERIMENT
  ),
  jobs: filteredState.get('jobs'),
  truncated: filteredState.get('truncated'),
  isOpenSauceUser: !user.isAuthenticated(),
  isOwner: filteredState.getIn(['build', 'owner']) === user.get('username'),
  rootCauseContribution: rootCauses.get('contribution'),
  isPerformanceEnabled: user.get('performance_enabled'),
  performanceFilter: filteredState.get('performanceFilter'),
}));

const stopBuildSelector = createSelector([
  builds,
], (filteredState) => {
  const [...runningJobsIds] = filteredState.get('jobs')
    .filter((job) => jobHelpers.getStatus(job.get('status')) === 'running')
    .keys();

  return ({
    buildOwner: filteredState.getIn(['build', 'owner']),
    runningJobsIds,
  });
});

export default containerSelector;
export {
  builds,
  containerSelector,
  stopBuildSelector,
};
